import React from 'react'
import { HolderDetail } from './styles'

export function MarginTopMobile ({className, children}) {
    return (
      <div className={`mt-8 mt-lg-0 ${className}`} >
          {children}
      </div>
    )
  }
  